import { render, staticRenderFns } from "./ProfileBoxes.vue?vue&type=template&id=9ceda8c4&scoped=true&"
import script from "./ProfileBoxes.vue?vue&type=script&lang=js&"
export * from "./ProfileBoxes.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBoxes.vue?vue&type=style&index=0&id=9ceda8c4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ceda8c4",
  null
  
)

export default component.exports